import type { NexusEvent } from "../../domain/mesh";
import { minutesAgo } from "./time";

export function createMockEvents(origin = Date.now()): NexusEvent[] {
  const ago = (minutes: number) => minutesAgo(minutes, origin);
  return [
    {
      id: "ev-01",
      type: "build.brief.updated",
      sourceNodeId: "build",
      targetNodeId: "house",
      timestamp: ago(4),
      severity: "success",
      payload: { version: 3 },
    },
    {
      id: "ev-02",
      type: "goal.progress.updated",
      sourceNodeId: "goals",
      targetNodeId: "house-goal",
      timestamp: ago(31),
      severity: "info",
      payload: { goal: "HOUSE", progress: 11 },
    },
    {
      id: "ev-03",
      type: "portfolio.deployed",
      sourceNodeId: "kaim-dev",
      targetNodeId: "portfolio-frontier",
      timestamp: ago(128),
      severity: "success",
      payload: { revision: "917cc61" },
    },
    {
      id: "ev-04",
      type: "photos.indexed",
      sourceNodeId: "photos",
      targetNodeId: "photo-archive",
      timestamp: ago(410),
      severity: "info",
      payload: { count: 20769 },
    },
    {
      id: "ev-05",
      type: "home.simulation",
      sourceNodeId: "home",
      targetNodeId: "house",
      timestamp: ago(690),
      severity: "warning",
    },
    {
      id: "ev-06",
      type: "market.integrity",
      sourceNodeId: "market-engine",
      targetNodeId: "goals",
      timestamp: ago(820),
      severity: "success",
    },
  ];
}

const pulseTemplates: Omit<NexusEvent, "id" | "timestamp">[] = [
  { type: "build.state.sampled", sourceNodeId: "build", targetNodeId: "house", severity: "info" },
  { type: "goals.market.sampled", sourceNodeId: "goals", targetNodeId: "market-engine", severity: "success" },
  { type: "portfolio.edge.sampled", sourceNodeId: "kaim-dev", targetNodeId: "portfolio-frontier", severity: "success" },
  { type: "photos.manifest.sampled", sourceNodeId: "photos", targetNodeId: "photo-archive", severity: "info" },
  { type: "home.awaiting-host", sourceNodeId: "home", targetNodeId: "house", severity: "warning" },
  { type: "location.context.sampled", sourceNodeId: "okolica", targetNodeId: "michalowice", severity: "info" },
];

export function createPulse(seed = Date.now()): NexusEvent {
  const template = pulseTemplates[Math.abs(seed) % pulseTemplates.length];
  return { ...template, id: `pulse-${seed}`, timestamp: new Date().toISOString() };
}
